import { RoutePage } from "@/components/RoutePage";
import { AISection } from "@/components/sections/AISection";

export default function AIPage({ onOpenContact }) {
  return (
    <RoutePage
      kicker="The AI"
      badge="AI"
      accent="#6366F1"
      title="Interpretable. Probabilistic. Closed-loop by construction."
      intro="Neural modeling shouldn't be a black box. The Neurobolt AI stack is designed around biological priors, calibrated uncertainty, and continuous feedback — so what the model believes is always something a scientist can verify."
      primaryCta="Talk to engineering"
      secondaryCta={{ href: "/applications", label: "Where it applies" }}
      onOpenContact={onOpenContact}
      prev={{ href: "/technology", label: "Technology" }}
      next={{ href: "/applications", label: "Applications" }}
      meta={{
        title: "AI Modeling",
        description:
          "Physics-aware, interpretable, probabilistic AI for neural signal modeling. Designed for continuous capture-model-feedback loops, not one-shot inference.",
        path: "/ai",
      }}
      stats={[
        { k: "4", v: "Modeling principles" },
        { k: "Physics", v: "-aware priors" },
        { k: "Uncertainty", v: "Quantified" },
        { k: "Loop-native", v: "By design" },
      ]}
    >
      <AISection />
    </RoutePage>
  );
}
